import { CookieManager } from './cookie-manager.js';
import './components/fam-card.js';
import './components/fam-course-card.js';
import './components/course-modal.js';
import './components/enrollment-modal.js';
import './components/fam-doc-card.js';
import './components/fam-colabora-item.js';
import './components/random-phrase.js';
import './components/fam-icon-box.js';
import './components/voluntariado-modal.js';
import './components/donar-modal.js';

// Inicialización de componentes globales
document.addEventListener('DOMContentLoaded', () => {
  CookieManager.init();
  loadReCaptcha();
});

/**
 * Carga dinámicamente el script de Google reCAPTCHA v3
 */
function loadReCaptcha() {
  const siteKey = process.env.PARCEL_PUBLIC_RECAPTCHA_SITE_KEY || '6Ld_placeholder_site_key_fam';
  if (!siteKey || siteKey.includes('placeholder')) {
    console.warn('reCAPTCHA: Site Key no configurada o usando placeholder.');
  }

  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
}

// ==================================================================
// Menú de navegación familiar
// ==================================================================
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.getElementById("famMenuBtn");
  const menu = document.getElementById("famMenu");
  if (!btn || !menu) return;

  btn.addEventListener("click", () => {
    menu.classList.toggle("hidden");
    btn.setAttribute(
      "aria-expanded",
      menu.classList.contains("hidden") ? "false" : "true"
    );
  });
});

// ==================================================================
// Submenús acordeón (header-v2 · menú móvil)
// ==================================================================
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".js-submenu-toggle").forEach((btn) => {
    btn.addEventListener("click", () => {
      const submenu = btn.nextElementSibling;
      if (!submenu || !submenu.classList.contains("js-submenu")) return;

      const isOpen = !submenu.classList.contains("hidden");

      // Cerrar todos los submenús abiertos
      document.querySelectorAll(".js-submenu").forEach((s) => {
        s.classList.add("hidden");
      });
      document.querySelectorAll(".js-submenu-toggle").forEach((b) => {
        b.setAttribute("aria-expanded", "false");
        const arrow = b.querySelector(".js-submenu-arrow");
        if (arrow) arrow.classList.remove("rotate-180");
      });

      // Si estaba cerrado, abrirlo
      if (!isOpen) {
        submenu.classList.remove("hidden");
        btn.setAttribute("aria-expanded", "true");
        const arrow = btn.querySelector(".js-submenu-arrow");
        if (arrow) arrow.classList.add("rotate-180");
      }
    });
  });

  // Para submenús anidados (nivel 2)
  document.querySelectorAll(".js-submenu-toggle-nested").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const submenu = btn.nextElementSibling;
      if (!submenu || !submenu.classList.contains("js-submenu-nested")) return;

      const isOpen = !submenu.classList.contains("hidden");

      if (!isOpen) {
        submenu.classList.remove("hidden");
        btn.setAttribute("aria-expanded", "true");
        const arrow = btn.querySelector(".js-submenu-arrow-nested");
        if (arrow) arrow.classList.add("rotate-180");
      } else {
        submenu.classList.add("hidden");
        btn.setAttribute("aria-expanded", "false");
        const arrow = btn.querySelector(".js-submenu-arrow-nested");
        if (arrow) arrow.classList.remove("rotate-180");
      }
    });
  });
});

// ==================================================================
// Año dinámico (footer-autor.html)
// ==================================================================
document.querySelectorAll(".js-year").forEach((el) => {
  el.textContent = new Date().getFullYear();
});





// ==================================================================
// Componente card-image.html (tarjeta con imagen, título y texto)
// ==================================================================
document.querySelectorAll("[data-card-title]").forEach((wrap) => {
  const card = wrap.querySelector(".js-card-image");
  if (!card) return;

  const img = card.querySelector(".js-card-image-img");
  const titleEl = card.querySelector(".js-card-image-title");
  const textEl = card.querySelector(".js-card-image-text");
  const ctaEl = card.querySelector(".js-card-image-cta");
  const titleBar = card.querySelector(".js-card-titlebar");
  const asset = wrap.querySelector("img.js-card-asset");

  const src = asset ? asset.getAttribute("src") : "";
  const alt = wrap.dataset.cardAlt || "";
  const title = wrap.dataset.cardTitle || "";
  const text = wrap.dataset.cardText || "";
  const link = (wrap.dataset.cardLink || "").trim();

  // Imagen
  if (img && src) {
    img.setAttribute("src", src);
    img.setAttribute("alt", alt || title);
  }

  // Texto
  if (titleEl) titleEl.textContent = title;
  if (textEl) textEl.textContent = text;

  // CTA: oculto por defecto
  if (ctaEl) ctaEl.style.display = "none";

  // Reset visual (por si se reinicializa)
  card.classList.remove(
    "cursor-pointer",
    "hover:border-accent",
    "hover:border-[4px]"
  );

  if (titleBar) {
    titleBar.classList.remove(
      "transition-colors",
      "duration-300",
      "group-hover:bg-accent"
    );
  }

  // Reset accesibilidad
  card.removeAttribute("role");
  card.removeAttribute("tabindex");

  if (link) {
    // Mostrar CTA
    if (ctaEl) ctaEl.style.display = "";

    // Card clicable + hover SOLO si hay link
    card.classList.add(
      "cursor-pointer",
      "hover:border-accent",
      "hover:border-[4px]"
    );

    // Hover franja título SOLO si hay link
    if (titleBar) {
      titleBar.classList.add(
        "group-hover:bg-accent"
      );
    }

    // Accesibilidad
    card.setAttribute("role", "link");
    card.setAttribute("tabindex", "0");

    // Evitar duplicar listeners
    if (!card.dataset.cardBound) {
      card.addEventListener("click", () => {
        window.location.href = link;
      });

      card.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          window.location.href = link;
        }
      });

      card.dataset.cardBound = "1";
    }
  }
});

// ==================================================================
// Componente hero-index (parametrizado + CTA opcional)
// Uso: wrapper con [data-hero] y dentro el <section class="js-hero">...
// Params (data-*):
// - data-hero-src, data-hero-alt
// - data-hero-title, data-hero-subtitle
// - data-hero-cta-label, data-hero-cta-link
// - data-hero-overlay (opcional): "0.30" | "30" | "bg-black/40" etc.
// ==================================================================
document.querySelectorAll("[data-hero]").forEach((wrap) => {
  const root = wrap.querySelector(".js-hero");
  if (!root) return;

  const img = root.querySelector(".js-hero-img");
  const overlayEl = root.querySelector(".js-hero-overlay");
  const titleEl = root.querySelector(".js-hero-title");
  const subtitleEl = root.querySelector(".js-hero-subtitle");
  const ctaEl = root.querySelector(".js-hero-cta");

  // -------------------------------
  // 1) Imagen (Parcel-friendly)
  // -------------------------------
  const asset = wrap.querySelector(".js-hero-asset");
  const src = (asset && asset.getAttribute("src")) || wrap.dataset.heroSrc || "";
  const alt = (wrap.dataset.heroAlt || "").trim();

  const title = (wrap.dataset.heroTitle || "").trim();
  const subtitle = (wrap.dataset.heroSubtitle || "").trim();

  if (img && src) {
    img.setAttribute("src", src);
    img.setAttribute("alt", alt || title || "Hero");
  }

  // -------------------------------
  // 2) Título / subtítulo (opcionales)
  // -------------------------------
  if (titleEl) {
    titleEl.textContent = title;
    titleEl.classList.toggle("hidden", title === "");
  }

  if (subtitleEl) {
    subtitleEl.textContent = subtitle;
    subtitleEl.classList.toggle("hidden", subtitle === "");
  }

  // -------------------------------
  // 3) Overlay (opcional)
  //    - Si pasas data-hero-overlay="bg-black/40" => sustituye clase base
  //    - Si pasas "0.3" o "30" => ajusta opacidad sobre negro
  // -------------------------------
  if (overlayEl) {
    const overlayRaw = (wrap.dataset.heroOverlay || "").trim();

    if (overlayRaw) {
      // Caso Tailwind class: "bg-black/40", "bg-black/50", etc.
      if (overlayRaw.startsWith("bg-")) {
        // Limpia posibles bg-* previas (simple y seguro)
        overlayEl.className = overlayEl.className
          .split(" ")
          .filter((c) => !c.startsWith("bg-"))
          .join(" ");
        overlayEl.classList.add(overlayRaw);
      } else {
        // Caso numérico: "0.3" o "30"
        let v = Number(overlayRaw);
        if (!Number.isNaN(v)) {
          if (v > 1) v = v / 100; // "30" => 0.3
          v = Math.max(0, Math.min(1, v));
          overlayEl.style.backgroundColor = `rgba(0,0,0,${v})`;
        }
      }
    }
  }

  // -------------------------------
  // 4) CTA opcional (blindado)
  // -------------------------------
  const ctaLabel = (wrap.dataset.heroCtaLabel || "").trim();
  const ctaLink = (wrap.dataset.heroCtaLink || "").trim();
  const hasCTA = ctaLabel !== "" && ctaLink !== "";

  if (ctaEl) {
    // Reset seguro
    ctaEl.classList.add("hidden");
    ctaEl.setAttribute("aria-hidden", "true");
    ctaEl.textContent = "";
    if (ctaEl.tagName === "A") ctaEl.removeAttribute("href");

    // Activar si procede
    if (hasCTA && ctaEl.tagName === "A") {
      ctaEl.textContent = ctaLabel;
      ctaEl.setAttribute("href", ctaLink);
      ctaEl.classList.remove("hidden");
      ctaEl.removeAttribute("aria-hidden");
    }
  }

  // -----------------------------------
  // Fondo de color a ancho completo (opcional)
  // -----------------------------------
  const bgClass = (wrap.dataset.heroBg || "").trim();
  if (bgClass) {
    root.classList.add(bgClass);
  }
});




// ==================================================================
// Componente split-overflow.html (hidratación + layout + altura imagen)
// ==================================================================
document.querySelectorAll("[data-split-overflow]").forEach((wrap) => {
  const root = wrap.querySelector(".js-split-overflow-root");
  if (!root) return;

  const grid = root.querySelector(".js-split-overflow-grid");
  const imageCol = root.querySelector(".js-split-overflow-image");
  const textCol = root.querySelector(".js-split-overflow-text");

  const figure = root.querySelector(".js-split-overflow-figure");
  const img = root.querySelector(".js-split-overflow-img");

  const titleEl = root.querySelector(".js-split-overflow-title");
  const parasEl = root.querySelector(".js-split-overflow-paras");

  const asset = wrap.querySelector(".js-split-overflow-asset");

  // Parámetros (X lateral, Y vertical)
  const overlapX = parseInt(wrap.dataset.splitOverlapX || "150", 10);
  const overlapY = parseInt(wrap.dataset.splitOverlapY || "50", 10);

  // Exponer X a CSS
  root.style.setProperty("--split-overlap-x", `${overlapX}px`);

  // Layout (image-left / image-right)
  const layout = (wrap.dataset.splitLayout || "image-right").trim();

  root.classList.toggle("is-image-left", layout === "image-left");
  root.classList.toggle("is-image-right", layout !== "image-left");

  if (grid) {
    grid.classList.add("grid", "gap-6", "lg:grid-cols-2", "items-center");
  }

  if (imageCol && textCol) {
    imageCol.classList.remove("lg:order-1", "lg:order-2");
    textCol.classList.remove("lg:order-1", "lg:order-2");

    if (layout === "image-left") {
      imageCol.classList.add("lg:order-1");
      textCol.classList.add("lg:order-2");
    } else {
      textCol.classList.add("lg:order-1");
      imageCol.classList.add("lg:order-2");
    }
  }

  // Imagen (Parcel-friendly)
  const src = asset ? asset.getAttribute("src") : "";
  const alt = wrap.dataset.splitAlt || "";

  if (img && src) {
    img.setAttribute("src", src);
    img.setAttribute("alt", alt);
  }

  // Exponer la imagen a CSS (para versión móvil “editorial”)
  if (src) {
    root.style.setProperty("--split-overflow-img", `url("${src}")`);
  }

  // Título
  const title = wrap.dataset.splitTitle || "";
  if (titleEl) titleEl.textContent = title;

  // Párrafos (separados por |) + salto visual
  const parasRaw = wrap.dataset.splitParas || "";
  if (parasEl) {
    parasEl.innerHTML = "";

    if (parasRaw.trim()) {
      const parts = parasRaw.split("|").map((t) => t.trim()).filter(Boolean);

      parts.forEach((text, index) => {
        const p = document.createElement("p");
        p.className = "text-lg leading-relaxed";
        if (index < parts.length - 1) p.classList.add("mb-4");
        p.innerHTML = text;
        parasEl.appendChild(p);
      });
    }
  }

  // Altura imagen = altura texto + overlapY (vertical)
  const card = textCol ? textCol.querySelector(":scope > div") : null;

  const applyHeight = () => {
    if (!figure || !card) return;

    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;

    if (!isDesktop) {
      figure.style.height = "";
      figure.style.marginTop = "";
      figure.style.marginBottom = "";
      return;
    }

    const textH = card.getBoundingClientRect().height;

    figure.style.height = `${Math.ceil(textH + overlapY)}px`;

    const half = Math.round(overlapY / 2);
    figure.style.marginTop = `-${half}px`;
    figure.style.marginBottom = `-${half}px`;
  };

  applyHeight();

  if (card && "ResizeObserver" in window) {
    const ro = new ResizeObserver(() => applyHeight());
    ro.observe(card);
  }

  window.addEventListener("resize", applyHeight, { passive: true });
});
